var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-card',{attrs:{"flat":""}},[_c('q-card-section',{staticClass:"card-scroll-section"},[_c('StepHeader',{attrs:{"title":_vm.stepperConfig.t(((_vm.step.key) + ".title")),"has-go-back":false,"image":_vm.step.image,"icon":_vm.ICON,"subtitle":_vm.stepperConfig.te(((_vm.step.key) + ".subtitle"))
          ? _vm.stepperConfig.t(((_vm.step.key) + ".subtitle"))
          : undefined}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }